/// <amd-module name="Wit/DeliveryPlans/Common/Services/DeliveryPlansTeamService" />

import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { isClassificationPathEqualOrUnderRelative } from "Wit/Common/NodeHelpers";
import { IDeliveryPlansWorkItem, ITeam } from "../Interfaces";

export interface IDeliveryPlansTeamService extends IVssService {
    addTeams(teams: ITeam[]): void;
    getTeam(teamId: string): ITeam | undefined;
    getTeamsFromWorkItem(workItem: IDeliveryPlansWorkItem): ITeam[];
    teamOwnsWorkItem(team: ITeam, workItem: IDeliveryPlansWorkItem): boolean;
}

class DeliveryPlansTeamService extends VssService implements IDeliveryPlansTeamService {
    private _teams: ITeam[] = [];

    public addTeams(teams: ITeam[]) {
        this._teams.push(...teams);
    }

    public getTeam(teamId: string): ITeam | undefined {
        return this._teams.find(t => t.id === teamId);
    }

    public getTeamsFromWorkItem(workItem: IDeliveryPlansWorkItem): ITeam[] {
        const teams = [];
        for (const t of this._teams) {
            if (this.teamOwnsWorkItem(t, workItem)) {
                teams.push(t);
            }
        }
        return teams;
    }

    public teamOwnsWorkItem(team: ITeam, workItem: IDeliveryPlansWorkItem): boolean {
        const fieldValue = workItem.getFieldValue<string>(team.teamFieldName);
        if (fieldValue === undefined || fieldValue === null) {
            return false;
        }

        return team.teamFieldValues.some(teamFieldValue =>
            isClassificationPathEqualOrUnderRelative(fieldValue, teamFieldValue.value, teamFieldValue.includeChildren)
        );
    }
}

Services.add("IDeliveryPlansTeamService", { serviceFactory: DeliveryPlansTeamService });
